import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import DsraPageUI from './DsraPageUI.js'

class DsraPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
    }
  }

  render() {
    return (
      <DsraPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        accpunt={this.state.account}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    this.setState({
      loan: null,
      errorList: null,
    })
    this.getLoan(context)
  }
}

export default withRouter(DsraPageSF)
